import { useActivityContext } from "@Context/game/activity/activity-context";
import { getPositionSelectionDisplayText } from "@hooks/game/selection/use-selection-display-text";
import useI18n from "@i18n";
import { Stack, Typography } from "@mui/material";
import {
  formatSessionDate,
  getChallengeTitle,
  getSessionModeConfig,
  getSessionPositions,
  type IUserSession,
} from "@Components/game/activity/utils";
import { SessionModeCell, SessionModeIcon, SessionRowCard, SessionRowGrid } from "@Components/game/activity/styled-components";
import formatMetricScoreType from "@Containers/app/stat-cards/tooltips/format-metric-type";
import MetricFilterTypes from "@Enums/MetricFilterTypes";

interface IActivitySessionRow {
  session: IUserSession;
}

const ActivitySessionRow = ({ session }: IActivitySessionRow) => {
  const { i18n } = useI18n();
  const { handleSessionClick } = useActivityContext();
  const modeConfig = getSessionModeConfig(session);
  const modeLabel = i18n(modeConfig.labelKey);
  const positionSelection = getPositionSelectionDisplayText(getSessionPositions(session), i18n);
  const challengeTitle = getChallengeTitle(session);

  return (
    <SessionRowCard onClick={() => handleSessionClick(session)}>
      <SessionRowGrid>
        <SessionModeCell>
          <SessionModeIcon src={modeConfig.icon} alt={modeLabel} />

          <Typography variant="textBase400" color="common.white" sx={{ minWidth: 0 }} noWrap>
            {modeLabel}
            {challengeTitle && (
              <Typography variant="textBase400" color="text.secondary" noWrap>
                {" · "} {challengeTitle}
              </Typography>
            )}
          </Typography>
        </SessionModeCell>

        <Typography variant="textBase400" color="common.white" noWrap>
          {formatSessionDate(session.updated_at)}
        </Typography>

        <Typography variant="textBase400" color="common.white" noWrap>
          {positionSelection}
        </Typography>

        <Stack direction="row" alignItems="center" justifyContent={{ xs: "flex-start", md: "flex-end" }} gap={1}>
          <Typography variant="textBase400">{formatMetricScoreType(MetricFilterTypes.BYB_IQ, session.byb_iq ?? 0)}</Typography>
          <Typography variant="textS400" color="text.secondary">
            {i18n("metric.byb_iq")}
          </Typography>
        </Stack>
      </SessionRowGrid>
    </SessionRowCard>
  );
};

export default ActivitySessionRow;
